<template>
  <div class="perfis-page">

    <!-- ── SEÇÃO: Ações ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-shield-account-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Perfis</div>
          <div class="form-section__sub">Gerencie os perfis de acesso do sistema</div>
        </div>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar perfil..."
          dense outlined hide-details color="#0052A0"
          style="max-width:280px"
          class="mr-3"
        />
        <v-btn color="#0052A0" rounded elevation="0" @click="abrirModalNovo" class="px-5">
          <v-icon left color="#FFD400" small>mdi-plus</v-icon>
          <span style="color:#FFD400;font-weight:700;font-size:13px">Novo Perfil</span>
        </v-btn>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        class="perfis-table elevation-0"
        no-data-text="Sem dados"
        :footer-props="{
          'items-per-page-text': 'Registros por página: ',
          'page-text': '{0}-{1} de {2}',
          'items-per-page-all-text': 'Listar todos',
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.label }}</td>
            <td class="text-center">
              <v-btn icon small color="#0052A0"
                :disabled="item.name == 'Super_Admin'"
                :to="{ name: 'Permissões para o perfil', params: { id: item.id, name: item.name } }"
                title="Permissões"
              >
                <v-icon small>mdi-account-cancel</v-icon>
              </v-btn>
              <v-btn icon small color="#0052A0" @click="abrirModalEditar(item)" title="Editar">
                <v-icon small>mdi-square-edit-outline</v-icon>
              </v-btn>
              <v-btn icon small color="error" @click="abrirModalInativar(item)" title="Excluir">
                <v-icon small>mdi-delete-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template v-slot:no-data><span>Sem dados</span></template>
        <template v-slot:no-results>
          <span>Sua busca por "{{ search }}" não encontrou resultados.</span>
        </template>
      </v-data-table>
    </div>

    <!-- ══ MODAL: Novo / Editar Perfil ══ -->
    <v-dialog v-model="dialog" persistent max-width="920px" scrollable>
      <v-card elevation="0">
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-shield-account-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">{{ modal.title }}</div>
            <div class="dialog-header__sub">Identificação e janelas de horário por dia da semana</div>
          </div>
          <v-spacer />
          <v-btn icon @click="dialog = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text class="pa-5 pt-4">
            <v-row dense>
              <v-col cols="4">
                <v-text-field label="Nome do perfil" required outlined dense color="#0052A0"
                  :rules="vazio" v-model="hand.name" />
              </v-col>
              <v-col cols="8">
                <v-text-field label="Descrição do perfil" required outlined dense color="#0052A0"
                  :rules="vazio" v-model="hand.label" />
              </v-col>
              <v-col cols="12"><v-divider /></v-col>
              <v-col cols="12" class="pb-0">
                <div class="perfil-section-label">Restrições de dias e horários de acesso</div>
                <div class="perfil-exp-sub">Defina em quais dias o perfil pode ser utilizado e o intervalo permitido (formato 24h, ex.: 08:00:00).</div>
                <div class="perfil-horario-actions">
                  <v-btn small outlined color="#0052A0" class="mr-2 mb-2" @click="ativarTodosDiasHorario">
                    <v-icon left small color="#0052A0">mdi-check-all</v-icon> Ativar todos
                  </v-btn>
                  <v-btn small outlined color="#64748b" class="mr-2 mb-2" @click="desativarTodosDiasHorario">
                    <v-icon left small>mdi-close-box-multiple-outline</v-icon> Desativar todos
                  </v-btn>
                  <v-btn small outlined color="#0052A0" class="mb-2" @click="replicarHorariosSegunda">
                    <v-icon left small color="#0052A0">mdi-content-copy</v-icon> Replicar horários de segunda
                  </v-btn>
                </div>
                <div class="perfil-horario-table-wrap">
                  <v-simple-table class="perfil-horario-table" dense>
                    <thead>
                      <tr>
                        <th class="text-left">Dia</th>
                        <th class="text-center perfil-th-ativo">Ativo</th>
                        <th>Horário inicial</th>
                        <th>Horário final</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in diasHorarioRows" :key="row.prefix">
                        <td class="perfil-dia-cell">{{ row.label }}</td>
                        <td class="text-center">
                          <v-switch v-model="hand[row.keyAcesso]" hide-details dense inset color="#0052A0" class="ma-0 perfil-switch-inline" />
                        </td>
                        <td>
                          <v-text-field v-model="hand[row.keyIni]" dense outlined hide-details color="#0052A0" placeholder="00:00:00" class="perfil-time-field" />
                        </td>
                        <td>
                          <v-text-field v-model="hand[row.keyFim]" dense outlined hide-details color="#0052A0" placeholder="23:59:59" class="perfil-time-field" />
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-spacer />
            <v-btn text rounded color="#64748b" @click="dialog = false" class="px-5">Cancelar</v-btn>
            <v-btn color="#0052A0" rounded elevation="0" :loading="carregando" :disabled="!valid" @click="validate" class="px-6">
              <v-icon left color="#FFD400" small>mdi-content-save-outline</v-icon>
              <span style="color:#FFD400;font-weight:700;font-size:13px">Salvar</span>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- ══ MODAL: Excluir Perfil ══ -->
    <v-dialog v-model="modalDelete" persistent max-width="420px">
      <v-card elevation="0">
        <div class="dialog-header dialog-header--danger">
          <div class="dialog-header__icon-wrap dialog-header__icon-wrap--danger">
            <v-icon color="#dc2626">mdi-delete-alert-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Excluir perfil</div>
            <div class="dialog-header__sub">{{ hand.name }}</div>
          </div>
          <v-spacer />
          <v-btn icon @click="modalDelete = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6">
          <p style="font-family:'Inter',sans-serif;color:#475569;font-size:0.9rem;">
            O perfil será removido permanentemente. Esta ação não pode ser desfeita.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer />
          <v-btn text rounded color="#64748b" @click="modalDelete = false" class="px-5">Cancelar</v-btn>
          <v-btn outlined rounded color="error" :loading="carregando" @click="inativarPerfil" class="px-5">
            <v-icon left small>mdi-delete-outline</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import helper from "../../../mixins/helper";

export default {
  components: {},
  mixins: [helper],
  data: () => ({
    dialog: false,
    modalDelete: false,
    carregando: false,
    valid: false,
    modal: {
      title: null,
      type: null,
    },
    menu: false,
    vazio: [(v) => !!v || "O campo não pode estar vazio"],
    hand: {
      id: null,
      name: null,
      label: null,
      segunda_acesso: null,
      segunda_ini: null,
      segunda_fim: null,

      terca_acesso: null,
      terca_ini: null,
      terca_fim: null,

      quarta_acesso: null,
      quarta_ini: null,
      quarta_fim: null,

      quinta_acesso: null,
      quinta_ini: null,
      quinta_fim: null,

      sexta_acesso: null,
      sexta_ini: null,
      sexta_fim: null,

      sabado_acesso: null,
      sabado_ini: null,
      sabado_fim: null,

      domingo_acesso: null,
      domingo_ini: null,
      domingo_fim: null,
    },
    list: [],
    search: "",
    headers: [
      { text: "Nome", width: "25%", value: "name", align: "start" },
      { text: "Descrição Perfil", value: "label", align: "start" },
      { text: "Ações", width: "15%", align: "center", value: "" },
    ],
  }),
  mounted() {
    this.getPerfis();
  },

  computed: {
    diasHorarioRows() {
      return [
        { label: "Segunda-feira", prefix: "segunda", keyAcesso: "segunda_acesso", keyIni: "segunda_ini", keyFim: "segunda_fim" },
        { label: "Terça-feira",   prefix: "terca",   keyAcesso: "terca_acesso",   keyIni: "terca_ini",   keyFim: "terca_fim" },
        { label: "Quarta-feira",  prefix: "quarta",  keyAcesso: "quarta_acesso",  keyIni: "quarta_ini",  keyFim: "quarta_fim" },
        { label: "Quinta-feira",  prefix: "quinta",  keyAcesso: "quinta_acesso",  keyIni: "quinta_ini",  keyFim: "quinta_fim" },
        { label: "Sexta-feira",   prefix: "sexta",   keyAcesso: "sexta_acesso",   keyIni: "sexta_ini",   keyFim: "sexta_fim" },
        { label: "Sábado",        prefix: "sabado",  keyAcesso: "sabado_acesso",  keyIni: "sabado_ini",  keyFim: "sabado_fim" },
        { label: "Domingo",       prefix: "domingo", keyAcesso: "domingo_acesso", keyIni: "domingo_ini", keyFim: "domingo_fim" },
      ];
    },
  },

  methods: {
    ativarTodosDiasHorario() {
      this.diasHorarioRows.forEach((row) => { this.$set(this.hand, row.keyAcesso, true); });
    },
    desativarTodosDiasHorario() {
      this.diasHorarioRows.forEach((row) => { this.$set(this.hand, row.keyAcesso, false); });
    },
    replicarHorariosSegunda() {
      const ini = this.hand.segunda_ini;
      const fim = this.hand.segunda_fim;
      ["terca", "quarta", "quinta", "sexta", "sabado", "domingo"].forEach((p) => {
        this.$set(this.hand, `${p}_ini`, ini);
        this.$set(this.hand, `${p}_fim`, fim);
      });
    },
    notificacao(title, msg, icon) {
      this.$swal({ toast: true, position: "top-center", showConfirmButton: false, timer: 3000, icon, title, text: msg });
    },
    getPerfis() {
      this.$http.get("perfisCrud").then(
        (response) => { this.list = response.data; },
        (response) => { console.log(response); }
      );
    },
    buildPayload() {
      const p = JSON.parse(JSON.stringify(this.hand));
      ["segunda_acesso","terca_acesso","quarta_acesso","quinta_acesso","sexta_acesso","sabado_acesso","domingo_acesso"].forEach((k) => {
        p[k] = p[k] ? 1 : 0;
      });
      return p;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.carregando = true;
        if (this.modal.type === "novo") this.criarPerfil();
        else if (this.modal.type === "editar") this.editarPerfil();
      }
    },
    abrirModalNovo() {
      this.modal.title = "Novo Perfil";
      this.modal.type = "novo";
      this.carregando = false;
      this.dialog = true;
      ["segunda","terca","quarta","quinta","sexta","sabado","domingo"].forEach((p) => {
        this.$set(this.hand, `${p}_acesso`, true);
        this.$set(this.hand, `${p}_ini`, "00:00:00");
        this.$set(this.hand, `${p}_fim`, "23:59:59");
      });
      this.$refs.form.resetValidation();
    },
    abrirModalEditar(item) {
      this.modal.title = "Editar Perfil";
      this.modal.type = "editar";
      this.hand = JSON.parse(JSON.stringify(item));
      const asBool = (v) => v == 1 || v === true;
      ["segunda","terca","quarta","quinta","sexta","sabado","domingo"].forEach((p) => {
        this.hand[`${p}_acesso`] = asBool(this.hand[`${p}_acesso`]);
      });
      this.carregando = false;
      this.dialog = true;
    },
    abrirModalInativar(data) {
      this.hand.id = data.id;
      this.hand.name = data.name;
      this.carregando = false;
      this.modalDelete = true;
    },
    criarPerfil() {
      this.$http.post("perfisCrud", { data: this.buildPayload() }).then(
        (response) => {
          this.carregando = false;
          this.getPerfis();
          this.dialog = false;
          this.$refs.form.reset();
          this.$refs.form.resetValidation();
          this.notificacao("", response.body.message, "success");
        },
        (response) => { this.carregando = false; this.notificacao("", response.body.message, "error"); }
      );
    },
    editarPerfil() {
      this.$http.put("perfisCrud/" + this.hand.id, { data: this.buildPayload() }).then(
        (response) => {
          this.carregando = false;
          this.getPerfis();
          this.dialog = false;
          this.$refs.form.reset();
          this.$refs.form.resetValidation();
          this.notificacao("", response.body.message, "success");
        },
        (response) => { this.carregando = false; this.notificacao("", response.body.message, "error"); }
      );
    },
    inativarPerfil() {
      this.carregando = true;
      this.$http.delete("perfisCrud/" + this.hand.id).then(
        (response) => {
          this.carregando = false;
          this.getPerfis();
          this.modalDelete = false;
          this.notificacao("", response.body.message, "success");
        },
        (response) => {
          this.carregando = false;
          this.modalDelete = false;
          this.notificacao("", response.body.message, "error");
        }
      );
    },
  },
};
</script>

<style scoped>
.perfis-page {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header {
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }

/* ── Dialog ── */
.dialog-header {
  display: flex; align-items: center; gap: 14px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 38px; height: 38px; background: #e8f0fe; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dialog-header__icon-wrap--danger { background: #fef2f2; }
.dialog-header__title { font-family: 'Inter', sans-serif; font-size: 1rem; font-weight: 700; color: #1e293b; }
.dialog-header__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; }

/* ── Tabela ── */
.perfis-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important; white-space: nowrap;
}
.perfis-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 10px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}

/* ── Horários ── */
.perfil-section-label {
  font-family: 'Inter', sans-serif; font-size: 0.78rem; font-weight: 700;
  color: #94a3b8; text-transform: uppercase; letter-spacing: 0.8px;
}
.perfil-exp-sub {
  font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #64748b;
  display: block; margin-top: 4px;
}
.perfil-horario-actions {
  display: flex; flex-wrap: wrap; align-items: center; gap: 4px 8px; margin-top: 12px;
}
.perfil-horario-table-wrap {
  border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden;
  margin-top: 12px; background: #fff;
}

@media (max-width: 768px) { .perfis-page { padding: 16px; } }
</style>

<style>
/* Estilos da tabela de horários precisam ser globais por ser v-simple-table */
.perfil-horario-table thead th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; border-bottom: 1px solid #e2e8f0 !important;
  padding: 10px 12px !important;
}
.perfil-horario-table tbody td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  vertical-align: middle !important; padding: 6px 12px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
.perfil-horario-table tbody tr:last-child td { border-bottom: none !important; }
.perfil-th-ativo { width: 88px; }
.perfil-dia-cell { font-weight: 600 !important; white-space: nowrap; min-width: 120px; }
.perfil-time-field { margin-top: 0 !important; padding-top: 0 !important; }
.perfil-time-field .v-input__slot { min-height: 36px !important; }
.perfil-switch-inline .v-input--selection-controls__input { margin-right: 0 !important; }
</style>
